<form [formGroup]="contactForm" (ngSubmit)="submitForm()">
  <h4 class="form-title">{{ "pickup-datetime" | translate }}</h4>
  <!-- Fecha y hora -->
  <section *ngIf="isValet()">
    <div class="gap-15 d-flex flex-column">
      <div class="gap-15 d-flex flex-column">
        <div class="valet">
          <div class="disclaimer">
            <div class="icon"></div>
            <div class="explication-disclaimer">
              <span [innerHTML]="'valetServiceDisclaimer' | translate"></span>
            </div>
          </div>
          <div
            class="d-flex flex-column gap-10 align-items-start valet-selector"
          >
            <div class="valet-label-selector">
              {{ "pick_up_location" | translate }}
            </div>
            <div class="select-container">
              <div
                class="custom-select"
                #customSelect
                (click)="toggleValetDropdown()"
                (keydown)="handleValetKeydown($event)"
                tabindex="0"
                role="combobox"
                [attr.aria-expanded]="isValetDropdownOpen"
                [attr.aria-controls]="'valet-options'"
                [ngClass]="{
                  'has-value': contactForm.get('valetStation')?.value
                }"
              >
                <span class="selected-option">
                  {{
                    getSelectedValetStationName() ||
                      ("select_location" | translate)
                  }}
                </span>
                <div class="chevron" [class.open]="isValetDropdownOpen"></div>
              </div>
              <div
                class="options-container"
                *ngIf="isValetDropdownOpen"
                id="valet-options"
              >
                <div class="options-scroll">
                  <div
                    *ngFor="let station of valetStations; let i = index"
                    class="option"
                    [class.selected]="
                      station === contactForm.get('valetStation')?.value
                    "
                    (click)="selectValetStation(station)"
                    (keydown)="handleValetOptionKeydown($event, station)"
                    tabindex="0"
                    role="option"
                    [attr.aria-selected]="
                      station === contactForm.get('valetStation')?.value
                    "
                  >
                    {{ station.StationName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pickup-date gap-15 d-flex flex-column">
        <div class="summary-information-box gap-10 fw-600 d-flex flex-column">
          <label for="pickup-date">{{ "pickup_day" | translate }}</label>
          <div class="calendar-picker-container w-100">
            <input
              type="text"
              class="form-control calendar-picker"
              #dp="bsDatepicker"
              bsDatepicker
              [daysDisabled]="[6, 0]"
              [minDate]="today"
              [bsConfig]="bsConfig"
              [datesDisabled]="productBlockedDates"
              autocomplete="off"
              (bsValueChange)="onPickupDateChangeForValet($event)"
              required
              placeholder="DD/MM/YYYY"
            />
            <div class="calendar-icon"></div>
          </div>
        </div>
        <div
          class="time-selector gap-10 w-100"
          *ngIf="isSpecificHours && !noAvailableHours"
        >
          <div class="custom-select-container" #pickUpTimeSelector>
            <label>{{ "pickup_time" | translate }}</label>
            <button
              type="button"
              class="custom-select custom-select-hour"
              #customSelect
              (click)="toggleDropdown()"
            >
              {{
                selectedHourPair
                  ? selectedHourPair.displayText
                  : "Selecciona una hora"
              }}
            </button>
            <div class="custom-options" [ngClass]="{ show: showDropdown }">
              <div
                *ngFor="let hour of availableHours"
                [ngClass]="{ selected: hour === selectedHourPair }"
                (click)="selectHourForValet(hour)"
                (keydown)="selectHourForValet(hour)"
                tabindex="0"
                class="custom-option"
              >
                {{ hour.displayText }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div
      class="summary-information-box gap-10 fw-600 d-flex flex-column w-100"
    >
      <label for="pickupTime">{{ "from" | translate }}</label>
      <div class="time-selector gap-10 d-flex">
        <div
          class="select-container d-flex flex-column align-items-center w-100"
        >
          <div class="clock"></div>
          <div class="custom-select-wrapper w-100">
            <div
              class="custom-select"
              (click)="togglePickupTimeDropdown()"
              tabindex="0"
              role="combobox"
              [attr.aria-expanded]="isPickupTimeDropdownOpen"
              [attr.aria-controls]="'pickup-time-options'"
            >
              <span class="selected-option">
                {{ selectedStartHour || "from" | translate }}
              </span>
              <div
                class="chevron"
                [class.open]="isPickupTimeDropdownOpen"
              ></div>
            </div>
            <div
              class="options-container"
              *ngIf="isPickupTimeDropdownOpen"
              id="pickup-time-options"
            >
              <div class="options-scroll">
                <div
                  *ngFor="let hour of availableStartHours; let i = index"
                  class="option"
                  (click)="selectPickupTime(hour)"
                  (keydown)="handlePickupTimeOptionKeydown($event, hour)"
                  tabindex="0"
                  role="option"
                  [attr.aria-selected]="hour === selectedStartHour"
                >
                  {{ hour.Text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
      </div>
      <div class="return-date gap-15 d-flex flex-column" *ngIf="isValet()">
        <h4 class="d-flex flex-row justify-content-start align-items-center">
          {{ "returnDateAndTime" | translate }}
        </h4>
        <div
          class="summary-information-box gap-10 fw-600 d-flex flex-column align-items-start align-self-stretch"
        >
          <label for="return-date">{{ "return_day" | translate }}</label>
          <div class="calendar-picker-container w-100">
            <input
              type="text"
              class="form-control calendar-picker d-flex justify-content-between align-items-center align-self-stretch"
              #dpReturn="bsDatepicker"
              bsDatepicker
              [daysDisabled]="[6, 0]"
              [minDate]="today"
              [bsConfig]="bsConfig"
              [datesDisabled]="productBlockedDates"
              autocomplete="off"
              (bsValueChange)="onReturnDateChangeForValet($event)"
              [(ngModel)]="returnDate"
              [ngModelOptions]="{ standalone: true }"
              required
              placeholder="DD/MM/YYYY"
            />
            <div class="calendar-icon"></div>
          </div>
        </div>
      </div>
      <div class="gap-15 d-flex flex-column" *ngIf="isValet()">
        <div
          class="time-selector gap-10 w-100"
          *ngIf="isReturnSpecificHours && isValet()"
        >
          <div
            class="custom-select-container d-flex flex-column gap-10"
            #returnTimeSelector
          >
            <label for="return-date" class="label">{{
              "returnTime" | translate
            }}</label>
            <button
              type="button"
              class="custom-select custom-select-hour"
              #customSelect
              (click)="toggleReturnDropdown()"
            >
              {{
                selectedReturnHourPair
                  ? selectedReturnHourPair.displayText
                  : "Selecciona una hora"
              }}
            </button>
            <div
              class="custom-options"
              [ngClass]="{ show: showReturnDropdown }"
            >
              <div
                *ngFor="let hour of availableReturnHours"
                [ngClass]="{ selected: hour === selectedReturnHourPair }"
                (click)="selectReturnHourForValet(hour)"
                (keydown)="selectReturnHourForValet(hour)"
                tabindex="0"
                class="custom-option"
              >
                {{ hour.displayText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="!isValet()">
    <label>{{ "pickup-day" | translate }}</label>
    <div class="calendar-picker-container w-100">
      <input
        type="text"
        class="form-control"
        bsDatepicker
        formControlName="serviceDate"
        [bsConfig]="bsConfig"
        placeholder="DD/MM/YYYY"
        autocomplete="off"
        (bsValueChange)="onReturnDateChange($event)"
      />
      <div class="calendar-icon"></div>
    </div>

    <div
      class="summary-information-box-pickup gap-10 fw-600 d-flex flex-column"
      *ngIf="showSpecificHoursSection"
    >
      <label for="pickup-date">{{ "pickup-time" | translate }}</label>
      <div class="select-container w-100">
        <div
          class="custom-select padding-left"
          #customSelect
          (click)="toggleSpecificHoursDropdown()"
          tabindex="0"
          role="combobox"
          [attr.aria-expanded]="isSpecificHoursDropdownOpen"
          [attr.aria-controls]="'specific-hours-options'"
        >
          <span class="selected-option">
            {{
              isSpecificHours
                ? ("scheduleWithSpecificTimesPrice" | translate)
                : ("scheduleWithTimeSlots" | translate)
            }}
          </span>
          <div class="chevron" [class.open]="isSpecificHoursDropdownOpen"></div>
        </div>
        <div
          class="options-container"
          *ngIf="isSpecificHoursDropdownOpen"
          id="specific-hours-options"
        >
          <div class="options-scroll">
            <div
              class="option"
              (click)="selectSpecificHours(false)"
              tabindex="0"
              role="option"
              [attr.aria-selected]="!isSpecificHours"
            >
              {{ "scheduleWithTimeSlots" | translate }}
              <label class="option-label">
                {{ "scheduleWithTimeSlotsDescription" | translate }}
              </label>
            </div>
            <div
              class="option"
              (click)="selectSpecificHours(true)"
              tabindex="0"
              role="option"
              [attr.aria-selected]="isSpecificHours"
            >
              {{ "scheduleWithSpecificTimesPrice" | translate
              }}<span> +6,00€</span>
              <label class="option-label">
                {{ "scheduleWithSpecificTimesPriceDescription" | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="time-range-selector d-flex gap-3">
      <div
        class="time-select-wrapper"
        *ngIf="
          !isSpecificHours && !noAvailableHours && showSpecificHoursSection
        "
      >
        <div
          class="summary-information-box gap-10 fw-600 d-flex flex-column w-100"
        >
          <label for="pickupTime">{{ "from" | translate }}</label>
          <div class="time-selector gap-10 d-flex">
            <div
              class="select-container d-flex flex-column align-items-center w-100"
            >
              <div class="clock"></div>
              <div class="custom-select-wrapper w-100">
                <div
                  class="custom-select"
                  #pickUpListener
                  (click)="togglePickupTimeDropdown()"
                  tabindex="0"
                  role="combobox"
                  [attr.aria-expanded]="isPickupTimeDropdownOpen"
                  [attr.aria-controls]="'pickup-time-options'"
                >
                  <span class="selected-option">
                    {{ selectedStartHour || "from" | translate }}
                  </span>
                  <div
                    class="chevron"
                    [class.open]="isPickupTimeDropdownOpen"
                  ></div>
                </div>
                <div
                  class="options-container"
                  *ngIf="isPickupTimeDropdownOpen"
                  id="pickup-time-options"
                >
                  <div class="options-scroll">
                    <div
                      *ngFor="let hour of availableStartHours; let i = index"
                      class="option"
                      (click)="selectPickupTime(hour)"
                      (keydown)="handlePickupTimeOptionKeydown($event, hour)"
                      tabindex="0"
                      role="option"
                      [attr.aria-selected]="hour === selectedStartHour"
                    >
                      {{ hour.Text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="summary-information-box gap-10 fw-600 d-flex flex-column w-100"
        >
          <label for="endHour">{{ "to" | translate }}</label>
          <div
            class="time-selector gap-10 w-100 d-flex"
            [ngClass]="{ 'gray-bg': noAvailableEndHours }"
          >
            <div
              class="select-container d-flex flex-column align-items-center w-100"
            >
              <div class="clock"></div>
              <div class="custom-select-wrapper w-100">
                <div
                  class="custom-select"
                  #endHourListener
                  (click)="toggleEndHourDropdown()"
                  tabindex="0"
                  role="combobox"
                  [attr.aria-expanded]="isEndHourDropdownOpen"
                  [attr.aria-controls]="'end-hour-options'"
                >
                  <span class="selected-option">
                    {{ selectedEndHour || "to" | translate }}
                  </span>
                  <div
                    class="chevron"
                    [class.open]="isEndHourDropdownOpen"
                  ></div>
                </div>
                <div
                  class="options-container"
                  *ngIf="isEndHourDropdownOpen"
                  id="end-hour-options"
                >
                  <div class="options-scroll">
                    <div
                      *ngFor="let hour of availableEndHours; let i = index"
                      class="option"
                      [class.selected]="hour === selectedEndHour"
                      (click)="selectEndHour(hour)"
                      tabindex="0"
                      role="option"
                      [attr.aria-selected]="hour === selectedEndHour"
                    >
                      {{ hour.Text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="time-selector gap-10 w-100"
        *ngIf="isSpecificHours && !noAvailableHours && showSpecificHoursSection"
      >
        <div class="custom-select-container">
          <label>{{ "Hora especifica" | translate }}</label>
          <button
            class="custom-select custom-select-hour"
            #customSelect
            (click)="toggleDropdown()"
          >
            {{
              selectedHourPair
                ? selectedHourPair.displayText
                : "Selecciona una hora"
            }}
          </button>
          <div class="custom-options" [ngClass]="{ show: showDropdown }">
            <div
              *ngFor="let hour of availableHours"
              [ngClass]="{ selected: hour === selectedHourPair }"
              (click)="selectHour(hour)"
              (keydown)="selectHour(hour)"
              tabindex="0"
              class="custom-option"
            >
              {{ hour.displayText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contacto de origen -->
  <section formGroupName="originContact">
    <h4 class="contact-form-title">
      {{
        contactForm.get("sameContact")?.value
          ? ("pickup-return-contact" | translate)
          : ("pickup-contact" | translate)
      }}
    </h4>

    <label>{{ "first-name" | translate }}</label>
    <input
      class="input-form"
      type="text"
      placeholder="Daniel"
      formControlName="name"
    />

    <label>{{ "last-name" | translate }}</label>
    <input
      class="input-form"
      type="text"
      placeholder="Parrales Sánchez"
      formControlName="lastName"
    />

    <label>{{ "email" | translate }}</label>
    <input
      class="input-form"
      type="email"
      placeholder="daniel15@gmail.com"
      formControlName="email"
    />

    <label for="phone">{{ "phone-number" | translate }}</label>

    <div class="phone-input-wrapper">
      <div class="select-wrapper" #selectWrapper>
        <select
          class="prefix-select"
          formControlName="originPhonePrefix"
          (click)="onSelectClick()"
          (change)="onSelectChange()"
        >
          <option value="+34">+34</option>
          <option value="+33">+33</option>
          <option value="+44">+44</option>
        </select>

        <mat-icon class="chevron-icon" [class.open]="isPrefixOpen"
          ><img src="assets/icons/chevron-down.svg" alt=""
        /></mat-icon>
      </div>

      <input
        class="input-form"
        type="tel"
        formControlName="phone"
        id="phone"
        placeholder="000 000 000"
      />
    </div>

    <div class="icon-and-help-text">
      <img
        class="iconssolidshield-exclamation"
        alt=""
        src="assets/icons/shield-exclamation-grey.svg"
      />
      <div class="lorem-ipsum-dolor-sit-amet-co-wrapper">
        <div class="lorem-ipsum-dolor">
          Utilizaremos tu número para coordinar la entrega y devolución de tu
          vehículo
        </div>
      </div>
    </div>
  </section>

  <!-- Checkbox -->
  <section>
    <!-- <label>
      <input type="checkbox" class="checkbox" formControlName="sameContact" (click)="toggleSameContact()" [checked]="sameContact"/>
      El contacto de recogida es el mismo que el de la entrega
    </label> -->
    <div class="check-box">
      <label>
        <input
          type="checkbox"
          name="pickup-contact-same-person"
          id="pickup-contact-same-person"
          (click)="toggleSameContact()"
          [checked]="sameContact"
        /><span class="check-box-text">{{
          "same-contact-checkbox" | translate
        }}</span></label
      >
    </div>
  </section>

  <!-- Contacto de destino (se muestra solo si no se usa el mismo contacto) -->
  <section
    *ngIf="!contactForm.get('sameContact')?.value"
    formGroupName="destinationContact"
  >
    <h4 class="contact-form-title">{{ "return-contact" | translate }}</h4>

    <label>{{ "first-name" | translate }}</label>
    <input
      type="text"
      class="input-form"
      placeholder="Daniel"
      formControlName="name"
    />

    <label>{{ "last-name" | translate }}</label>
    <input
      type="text"
      class="input-form"
      placeholder="Parrales Sánchez"
      formControlName="lastName"
    />

    <label>{{ "email" | translate }}</label>
    <input
      type="email"
      class="input-form"
      placeholder="daniel15@gmail.com"
      formControlName="email"
    />

    <label for="phone">{{ "phone-number" | translate }}</label>
    <div class="phone-input-wrapper">
      <select class="prefix-select" formControlName="destinationPhonePrefix">
        <option value="+34">+34</option>
        <option value="+33">+33</option>
        <option value="+44">+44</option>
      </select>

      <input
        class="input-form"
        type="tel"
        formControlName="phone"
        id="phone"
        placeholder="000 000 000"
      />
    </div>
  </section>

  <!-- Instrucción adicional -->
  <div class="additional-instruction-container">
    <label class="field-label"
      >{{ "need-extra-instructions" | translate }}
      <span class="optional">({{ "optional" | translate }})</span>
    </label>
    <div class="textarea-wrapper">
      <textarea
        class="custom-textarea"
        [placeholder]="placeholder"
        maxlength="500"
        formControlName="extraInstructions"
      >
      </textarea>
    </div>
  </div>
  <app-first-information-layer></app-first-information-layer>
  <div class="button-container">
    <ng-content select="[left-button]"></ng-content>
    <button type="submit" class="continue-button2">
      {{ "continue" | translate }}
    </button>
  </div>
</form>
